import { render, staticRenderFns } from "./BrandVoicesSelect.vue?vue&type=template&id=69077622"
import script from "./BrandVoicesSelect.vue?vue&type=script&lang=js"
export * from "./BrandVoicesSelect.vue?vue&type=script&lang=js"
import style0 from "./BrandVoicesSelect.vue?vue&type=style&index=0&id=69077622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports